<div [formGroup]="form">
	<div class="modal-header">
		<h2 class="modal-title">{{ isEditing ? 'Edit Tax Rate' : 'Add Tax Rate' }}</h2>
		<button type="button" class="btn btn-close" aria-label="Close" (click)="cancel()">
			<i class="fal fa-xmark"></i>
		</button>
	</div>
	<div class="modal-body">
		<rl-form-table-row labelText="Tax Rate %" [required]="true">
			<ng-template rlFormTableControl>
				<input aria-label="Tax Rate" class="form-control" type="number" step="0.0001"
					placeholder="'Enter Tax Rate" formControlName="taxRate" data-cy="taxRate" />
			</ng-template>
		</rl-form-table-row>
		@if (isAccProTaxManagementEnabled) {
			<rl-form-table-row [labelText]="taxCodeLabel">
				<ng-template rlFormTableControl>

					<rl-text-input [placeholder]="'Enter ' + taxCodeLabel" formControlName="taxCode" data-cy="taxCode">
					</rl-text-input>

				</ng-template>
			</rl-form-table-row>
		}
		<rl-form-table-row [labelText]="territoryLabel" [required]="true">
			<ng-template rlFormTableControl>
				@if (territoryCmd) {
					<rl-char-data-element [cmd]="territoryCmd" [charData]="form.controls.territoryXchrValId.value"
						[formControl]="form.controls.territoryXchrValId" [editMode]="true"
						[elementUsage]="CharDataElementUsage.CharDataTable" data-cy="territory">
					</rl-char-data-element>
				}
			</ng-template>
		</rl-form-table-row>
		<rl-form-table-row [labelText]="stateProvinceLabel">
			<ng-template rlFormTableControl>
				<rl-text-input [placeholder]="'Enter ' + stateProvinceLabel" formControlName="stateProvince"
					data-cy="stateProvince">
				</rl-text-input>
			</ng-template>
		</rl-form-table-row>
		<rl-form-table-row [labelText]="postalCodeLabel">
			<ng-template rlFormTableControl>
				<rl-text-input [placeholder]="'Enter ' + postalCodeLabel" formControlName="postalCode"
					data-cy="postalCode">
				</rl-text-input>
			</ng-template>
		</rl-form-table-row>
		<rl-form-table-row labelText="Effective Date" [required]="true">
			<ng-template rlFormTableControl>
				<rl-date-input formControlName="effectiveDate" [allowPerpetuity]="false" data-cy="effectiveDate">
				</rl-date-input>
			</ng-template>
		</rl-form-table-row>
		<rl-form-table-row labelText="Active">
			<ng-template rlFormTableControl>
				<rl-checkbox-input formControlName="activeIndicator" [dataLabel]="'activeIndicator'">
				</rl-checkbox-input>
			</ng-template>
		</rl-form-table-row>
	</div>
	<div class="modal-footer">
		<button type="button" class="btn btn-light me-1" (click)="cancel()">Cancel</button>
		<button type="button" class="btn btn-success" [class.btn-edit]="isEditing" (click)="save()"
			[disabled]="!canSave">
			@if (isSubmitting) {
				<i class="fal fa-spinner fa-spin me-1"></i>
			}
			{{ isEditing ? 'Update' : 'Add' }}
		</button>
	</div>
</div>